import { render, staticRenderFns } from "./CartTreatment.vue?vue&type=template&id=69fb6fdd&scoped=true"
import script from "./CartTreatment.vue?vue&type=script&lang=js"
export * from "./CartTreatment.vue?vue&type=script&lang=js"
import style0 from "./CartTreatment.vue?vue&type=style&index=0&id=69fb6fdd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69fb6fdd",
  null
  
)

export default component.exports